import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchInvestmentTechnical } from '@apis/investmentIndicators';
import type { InvestmentTechnicalApiData } from '@app-types/investmentIndicatorsApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

export const useInvestmentTechnical = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<InvestmentTechnicalApiData>({
    queryKey: ['indicators', 'technical', ticker, mkt],
    queryFn: () => fetchInvestmentTechnical({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};

